import { render, staticRenderFns } from "./SelectEdition.vue?vue&type=template&id=60292b36&"
import script from "./SelectEdition.vue?vue&type=script&lang=js&"
export * from "./SelectEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports